module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/basketball-dbb7b9bd3457ae302a61edf043127c16.svg";